module.exports = __webpack_public_path__ + "static/media/nf.05a6cb0f.svg";